<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='horizontal' :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model='queryParam.mobileNo'></a-input>
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t('customer.curp')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t('customer.curp'))"
                         v-model='queryParam.curp'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'loanStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.loanStatus'
                  :dict-code='DICT_CODE.LOAN_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'approvalStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.approvalStatus'
                  :dict-code='DICT_CODE.ORDER_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'settlementStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.settleStatus'
                  :dict-code='DICT_CODE.SETTLE_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                >
                </dict-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'applicationTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="12">
              <a-form-item :label="'主产品'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.mainSids'
                  allowClear
                >
                  <a-select-option v-for='item in mainAppList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12' >
              <a-form-item :label="'产品类型'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.appSsid'
                  allowClear
                >
                  <a-select-option v-for='item in appList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12' v-if="hasAdmin">
              <a-form-item
                :label="'风控盘'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.riskAppSsid'
                  allowClear
                >
                  <a-select-option v-for='item in riskAppList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'custType')">
                <a-select default-value='' style='width: 100%' v-model='queryParam.custType'>
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    新户
                  </a-select-option>
                  <a-select-option value='2'>
                    老户
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'paymentTime')">
                <a-range-picker
                  v-model='queryParam.paymentTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'expireTime')">
                <a-range-picker
                  v-model='queryParam.endTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'overdueStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.overdueStatus'
                  :dict-code='DICT_CODE.OVERDUE_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                >
                </dict-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="'订单类型'">
                <a-select default-value='' style='width: 100%' v-model='queryParam.orderType'>
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    展期订单
                  </a-select-option>
                  <a-select-option value='0'>
                    正常订单
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md='6' :sm='8'>-->
<!--              <a-form-item :label="$t('order.applicationDeadline')">-->
<!--                <a-select mode='multiple' default-value='' style='width: 190px' v-model='queryParam.durations'>-->
<!--                  <a-select-option v-for='item in deadlineConfigList' :key='item.itemValue'>-->
<!--                    {{ item.itemText }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
          </template>
          <a-col :md='8' :sm='12'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
<!--              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>-->
              <a-button v-if="roleCodes.includes('om_download') || roleCodes.includes('om')" type="primary" :disabled="!downloadAble" @click="downLoadData" icon="download" style="margin-left: 8px">导出</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
        <span v-if="isSearch" slot='action' slot-scope='text, record'>
          <!-- slot-scope="text, record" -->
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
    <v-modal
      v-model='visible'
      :title="$t(I18N_KEY + 'orderDetail')">
      <div style='padding: 20px;'>
        <order-detail v-if='visible' :orderId='orderId' :custInfoId='custInfoId' :mobileNo='mobileNo' :isQuerySummary="true"/>
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getPlatformAllOrderList, getRoleCode, getApplistExcludingSubApp } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'
import moment from 'moment'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import exportFile from '@/api/exportFile'

const I18N_KEY = 'order.'
export default {
  name: 'AllOrderList',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail
  },
  data() {
    return {
      I18N_KEY,
      roleCodes:[],
      toggleSearchStatus: false,
      hasAdmin: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      mobileNo: undefined,
      downloadAble: true,
      isSearch: true,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      deadlineConfigList: [],
      // 查询条件
      queryParam: {
        'mainSids': '',
        'orderNo': '',
        'mobileNo': '',
        'aadhaarName': '',
        'createdTime': undefined,
        'paymentTime': undefined,
        'endTime': undefined,
        'overdueStatus': '',
        'loanStatus': '',
        'approvalStatus': '',
        'settleStatus': '',
        'appSsid': '',
        // 'durations': undefined,
        'custType': '',
        'riskAppSsid': ''
      },
      loading: false,
      // 表头
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      appList: [],
      riskAppList: [],
      mainAppList: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'appSsids'),
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t(I18N_KEY + 'productName'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t(I18N_KEY + 'custType'),
          align: 'left',
          dataIndex: 'loanCount',
          customRender: (text, row) => {
            if (text > 1) {
              return '老户'
            } else {
              return '新户'
            }
          }
        },
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t('customer.names'),
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: this.$t('customer.surnames'),
          align: 'left',
          dataIndex: 'surnames'
        },
        {
          title: this.$t('customer.curp'),
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t(I18N_KEY + 'loanAmount'),
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        // {
        //   title: this.$t(I18N_KEY + 'deadline'),
        //   align: 'left',
        //   dataIndex: 'duration'
        // },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'paymentTime'),
          align: 'left',
          dataIndex: 'paymentTime'
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementTime'),
          align: 'left',
          dataIndex: 'settleTime'
        },
        {
          title: this.$t(I18N_KEY + 'overdueStatus'),
          align: 'left',
          dataIndex: 'overdueStatus',
          scopedSlots: { customRender: 'overdueStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t(I18N_KEY + 'expireTime'),
          align: 'left',
          dataIndex: 'endDate'
        },
        // {
        //   title: '申请期限',
        //   align: 'center',
        //   dataIndex: 'duration'
        // },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    // this.loadData(1)
    this.getIsShowRiskBtn();
    getRoleCode().then(res => {
      this.roleCodes = res.data || []
    })
    getApplist().then(res => {
      let filteredData = res.data
      // if(this.roleCodes.includes('tel_market_admin'))
      // {
      //     filteredData = res.data.filter((item, index) =>
      //       index === 0 || (item.appssid && item.appssid.includes("139"))
      //     )
      // }

      this.appList = filteredData || []
    })
    getApplist({ riskType: 'risk' }).then(res => {
      let filteredData = res.data
      // if(this.roleCodes.includes('tel_market_admin'))
      // {
      //     filteredData = res.data.filter((item, index) =>
      //       index === 0 || (item.appssid && item.appssid.includes("139"))
      //     )
      // }

      this.riskAppList = filteredData || [];
    })
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
    getApplistExcludingSubApp().then(res => {
      this.mainAppList = []
      this.mainInAppList = res.data || []
      for (var i = 0; i < this.mainInAppList.length; i++) {
        if (this.mainInAppList[i].appssid != '') {
          this.mainAppList.push(this.mainInAppList[i])
        }
      }
    });
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    getIsShowRiskBtn() {
      const roleCodeStr = localStorage.getItem('roleCodes');

      try {
        // 1. 把字符串解析为真正的数组（JSON.parse 处理JSON格式字符串）
        const roleCodeArray = JSON.parse(roleCodeStr);
        // 2. 先判断解析后是数组，再用includes判断
        if (Array.isArray(roleCodeArray)) {
          this.hasAdmin = roleCodeArray.includes('SUPER_ADMIN') || roleCodeArray.includes('admin');
        }
      } catch (e) {
        // 防错：如果字符串格式错误（如语法问题），不会报错，默认false
        this.hasAdmin = false;
      }

    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getPlatformAllOrderList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
          // if (this.queryParam.durations == '' || this.queryParam.durations == undefined) {
          //   this.dataSource.forEach(item => {
          //     item.duration = '--'
          //   })
          // }
          //处理操作列中按钮的显示

          if (this.queryParam.riskAppSsid === null || this.queryParam.riskAppSsid === undefined || this.queryParam.riskAppSsid.trim() === '') {
            this.isSearch = true;
          } else {
            this.isSearch = false;
          }
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { createdTime } = this.queryParam
      const { paymentTime } = this.queryParam
      const { endTime } = this.queryParam
      const data = {
        ...this.queryParam,
        applyDateStart: (createdTime && createdTime.length) ? this.transformTime(createdTime[0]) : undefined,
        applyDateEnd: (createdTime && createdTime.length) ? this.transformTime(createdTime[1]) : undefined,
        // applyDateStart: createdTime && this.transformTime(createdTime[0]),
        // applyDateEnd: createdTime && this.transformTime(createdTime[1]),
        paymentTimeStart: (paymentTime && paymentTime.length) ? this.transformTime(paymentTime[0]) : undefined,
        paymentTimeEnd: (paymentTime && paymentTime.length) ? this.transformTime(paymentTime[1]) : undefined,
        // paymentTimeStart: paymentTime && this.transformTime(paymentTime[0]),
        // paymentTimeEnd: paymentTime && this.transformTime(paymentTime[1]),
        endDateStart: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined,
        // endDateStart: endTime && this.transformTime(endTime[0]),
        // endDateEnd: endTime && this.transformTime(endTime[1])
      }
      delete data.createdTime
      delete data.paymentTime
      delete data.endTime
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.paymentTime = undefined
      that.queryParam.createdTime = undefined
      that.queryParam.endTime = undefined
      that.queryParam.overdueStatus = ''
      that.queryParam.loanStatus = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      that.queryParam.appSsid = ''
      that.queryParam.riskAppSsid = ''
      that.queryParam.orderType = ''
      // that.queryParam.durations = undefined
      that.queryParam.custType = ''
      that.queryParam.curp=''
      this.dataSource = []
      that.queryParam.mainSids = '';


      // that.loadData(this.form.pageNum)
    },
    downLoadData () {

      this.$confirm({
        title: '确认导出',
        content: "最多导出10000条数据，请控制时间范围，是否确认导出？",
        onOk: () => {
          this.downloadAble = false;
          var params = this.getQueryParams();
          // const queryParams = this.getQueryParams()// 查询条件
          // const params = new URLSearchParams();

          // for (const [key, value] of Object.entries(queryParams)) {
          //   // 跳过undefined和空字符串
          //   if (value) {
          //      params.append(key, encodeURIComponent(value.toString()));
          //   }
          // }

          const file = {
            fileUrl: '/api/web/webpublic/platform/order/exportOrderExcel?orderNo=' + params.orderNo + '&mobileNo=' + params.mobileNo + '&curp=' + params.curp  + '&applyDateStart=' + params.applyDateStart  + '&applyDateEnd=' + params.applyDateEnd  + '&loanStatus=' + params.loanStatus  + '&approvalStatus=' + params.approvalStatus  + '&settleStatus=' + params.settleStatus + '&appSsid=' + params.appSsid + '&custType=' + params.custType + '&orderType=' + params.orderType + '&paymentTimeStart=' + params.paymentTimeStart + '&paymentTimeEnd=' + params.paymentTimeEnd + '&endDateStart=' + params.endDateStart + '&endDateEnd=' + params.endDateEnd + '&overdueStatus=' + params.overdueStatus
            + '&mainSids=' + params.mainSids + '&riskAppSsid=' + params.riskAppSsid,
            fileName:   'order.xlsx',
          }
          exportFile(file).catch(e => {
            this.$message.error(e.message);
          }).finally(() => {
            this.downloadAble = true;
          })
        },
        onCancel: () => {

        }
      })
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.mobileNo = row.mobileNo
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
